import { SseEvents, SseResultObject } from '../states';
import { StateRequest } from './RequestReducer';

export const initialStateOperationStarted: StateRequest<
  SseResultObject[SseEvents.OPERATION_STARTED]
> = {
  loading: true,
  error: false,
};

export const initialStateSelfieCaptured: StateRequest<
  SseResultObject[SseEvents.SELFIE_CAPTURED]
> = {
  loading: true,
  error: false,
};

export const initialStateFacialAuthentication: StateRequest<
  SseResultObject[SseEvents.FACIAL_AUTHENTICATION_EVALUATED]
> = {
  loading: true,
  error: false,
};

export const initialStatePassiveLiveness: StateRequest<
  SseResultObject[SseEvents.PASSIVE_LIVENESS_EVALUATED]
> = {
  loading: true,
  error: false,
};

export const initialStateOperationFinished: StateRequest<
  SseResultObject[SseEvents.OPERATION_FINISHED]
> = {
  loading: true,
  error: false,
};

export const initialStateOperationExpired: StateRequest<
  SseResultObject[SseEvents.OPERATION_EXPIRED]
> = {
  loading: true,
  error: false,
};
